const f = (t) => t == null ? void 0 : t.data, R = (t) => {
  var a;
  return (a = t == null ? void 0 : t.data) == null ? void 0 : a.data;
}, b = (t) => {
  var g, l;
  if (!t) return;
  let a, i, u = !1;
  if ("headers" in t && "error" in t) {
    const { errCode: d, statusCode: c, message: e } = t.error || {};
    a = d || c || t.code || ((g = t.data) == null ? void 0 : g.code), i = ((l = t.data) == null ? void 0 : l.message) || t.message || e;
  } else {
    let {
      code: d,
      message: c,
      success: e
    } = "data" in t ? (t == null ? void 0 : t.data) || {} : t || {};
    if ("details" in t && typeof t.details == "object" && t.details) {
      const { errCode: m, message: s } = t.details;
      m && s && (d = m, c = s);
    }
    "message" in t && c === void 0 && ({ code: d, message: c, success: e } = t), a = d, i = c, u = !!e;
  }
  return {
    code: a,
    message: i,
    success: u
  };
}, A = (t) => ({
  success: !0,
  code: 200,
  data: t
}), C = (t) => ({
  success: !0,
  code: 200,
  data: {
    success: !0,
    code: 200,
    data: t
  }
});
export {
  C as buildSuccessApiRequestResponse,
  A as buildSuccessRequestResponse,
  f as getApiData,
  R as getApiResponseData,
  b as getResponse
};
